import { Question } from './Question';
import { ScoreWeight } from './ScoreWeight';

export class ScoreTypeInconsistent {
    public questionOne: Question;
    public questionTwo: Question;
}

export class ScoreType {
    public id: number;
    public name: string;
    public scoreAlgorithm: number;
    public scoringType: string;
    public surveyVersionID: number;
    public scoreTypeInconsistents: ScoreTypeInconsistent[];
    public scoreWeights: ScoreWeight[];
    public area: string;
    public sort: number;
}


// WEBPACK FOOTER //
// ./src/models/ScoreType.tsx